"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneLabel = exports.default = void 0;
var timezone_label_component_1 = require("./timezone-label.component");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(timezone_label_component_1).default; } });
Object.defineProperty(exports, "TimezoneLabel", { enumerable: true, get: function () { return timezone_label_component_1.TimezoneLabel; } });
